import React from 'react'
import {css} from '@emotion/react'
import styled from '@emotion/styled'
import {BookingError} from 'hooks/useBookingError'
import {NETWORK_ERROR} from 'modules/common/constants'
import {ThemeType} from 'types/Theme'

import {Text} from '@daedalus/atlas/src/components/designSystem/Text'
import FormattedMessageWrapper from '@daedalus/core/src/localization/components/FormattedMessage'

import {OverlayErrorMessage} from '../OverlayErrorMessage'

const Title = styled('div')(
  ({theme}: {theme: ThemeType}) => css`
    ${theme.typography.text.titleXL};
    margin-bottom: ${theme.layout.spacing.s600}px;
  `
)

export const getIsConnectionError = (error?: BookingError) => {
  return (
    error?.status === 500 ||
    (error?.data as unknown as string) === NETWORK_ERROR
  )
}

export const ConnectionError = React.memo(() => {
  return (
    <OverlayErrorMessage>
      <Title>
        <FormattedMessageWrapper
          id="errors.connectionErrorTitle"
          defaultMessage="Connection error"
        />
      </Title>
      <Text>
        <FormattedMessageWrapper
          id="errors.connectionErrorDescription"
          defaultMessage="There was an error while confirming your booking – but it’s still being processed.<br></br><br></br>If you don’t receive a confirmation email, please contact support and don’t try to make a new booking."
          values={{br: () => <br />}}
        />
      </Text>
    </OverlayErrorMessage>
  )
})

ConnectionError.displayName = 'ConnectionError'
